import { Buffer } from 'buffer';

// Make Buffer available globally
window.Buffer = Buffer;

// Add any other polyfills here if needed in the future 